import React, { createContext, useContext } from "react";
import useNotificationCenter from "../../hooks/useNotificationCenter";

const NotificationContext = createContext(null);
function Session({ children, ...props }) {
  const value = useNotificationCenter(props);
  return <NotificationContext.Provider value={value}>{children}</NotificationContext.Provider>;
}
export function NotificationCenterProvider({ user, ...props }) {
  return <Session key={`${user?.companyId}:${user?.id}`} user={user} {...props} />;
}
export const useNotifications = () => useContext(NotificationContext);
